module.exports = __webpack_public_path__ + "76c3960838b602acf6aa414705cf987b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/community-distance.png
// module id = 1862
// module chunks = 1